import { ContainerModule, type ContainerModuleLoadOptions } from 'inversify';
import { ClientGameDependencyTypes } from '@client/entity/client-game/client-game.dependency-types';
import { ClientGameApiDataTransformer } from '@client/entity/client-game/data/transformer/client-game.api-data-transformer';
import { ClientGameRepository } from '@client/entity/client-game/data/repository/client-game.repository';
import { ClientGameApiService } from '@client/entity/client-game/data/service/client-game.api-service';
import { ClientGameService } from '@client/entity/client-game/domain/service/client-game.service';
import { ClientGamesRefreshCompletionDispatcherService } from '@client/entity/client-game/domain/service/client-games-refresh-completion-dispatcher.service';

export const clientGameContainerModule = new ContainerModule((options: ContainerModuleLoadOptions) => {
  options
    .bind<ClientGameApiService>(ClientGameDependencyTypes.ClientGameApiService)
    .to(ClientGameApiService)
    .inSingletonScope();
  options
    .bind<ClientGameApiDataTransformer>(ClientGameDependencyTypes.ClientGameApiDataTransformer)
    .to(ClientGameApiDataTransformer)
    .inSingletonScope();
  options
    .bind<ClientGameRepository>(ClientGameDependencyTypes.ClientGameRepository)
    .to(ClientGameRepository)
    .inSingletonScope();
  options.bind<ClientGameService>(ClientGameDependencyTypes.ClientGameService).to(ClientGameService).inSingletonScope();
  options
    .bind<ClientGamesRefreshCompletionDispatcherService>(
      ClientGameDependencyTypes.ClientGamesRefreshCompletionDispatcherService,
    )
    .to(ClientGamesRefreshCompletionDispatcherService);
});
